import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { ModalController, ToastController } from '@ionic/angular';

@Component({
  selector: 'app-noc-approve-case',
  templateUrl: './noc-approve-case.component.html'
})
export class NocApproveCaseComponent implements OnInit {
  approveForm: FormGroup = new FormGroup({});
  pan: string;
  applicantName: string;

  constructor(private modalCtrl: ModalController, private toastController: ToastController) { }

  ngOnInit(): void { 
    this.approveForm = new FormGroup({
      outwardNo: new FormControl(null, [Validators.required])
    });  
  }


  async showErrorToast(errorMessage: string) {
    const toast = await this.toastController.create({
      message: errorMessage,
      icon: "information-circle",
      position: "top",
      duration: 2000,
    });
    toast.present();
  }
  approve() {
     if (!this.approveForm.value.outwardNo){
       this.showErrorToast("Please Enter Approval Remark");
     }
     
    if (this.approveForm.valid) {
      return this.modalCtrl.dismiss(this.approveForm.value.outwardNo, 'approve');
    }
    else {
      
    }
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  public space(event:any){

    if (event.target.selectionStart === 0 && event.code === 'Space'){
      event.preventDefault();
    }
    }

}
